import * as styles from './BadgedIcon.css';

type BadgedIconProps = {
  icon: React.ReactNode;
  withBadge?: boolean;
};

export const BadgedIcon = ({ icon, withBadge }: BadgedIconProps) => {
  return (
    <div className={styles.container}>
      {icon}
      {withBadge && <div className={styles.iconBadge} />}
    </div>
  );
};
